// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../../utils/Utils.bs.js");
let FilterChip = require("../../common/Components/FilterChip.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SearchPagesUtils = require("../../common/SearchPagesUtils.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertyFilterOptions = require("../../common/Form/PropertyFilterOptions.bs.js");
let ClientNeedsPageRelayQueryParams = require("./ClientNeedsPageRelayQueryParams.bs.js");

function ClientNeedsPageRelayActiveFiltersList(props) {
  let refetch = props.refetch;
  let params = props.params;
  let rentalMode = params.rentalMode;
  let priceOptions = rentalMode ? PropertyFilterOptions.PriceFilters.rentalOptions : PropertyFilterOptions.PriceFilters.forSaleOptions;
  let activeParams = props.selectedAreas.filter(a => Stdlib_Option.getOr(params.areaIds, []).includes(a.id)).map(area => [
    area.label,
    q => {
      let newrecord = {...q};
      let v = Stdlib_Option.getOr(q.areaIds, []).filter(id => id !== area.id);
      newrecord.areaIds = v.length !== 0 ? v : undefined;
      return newrecord;
    }
  ]);
  let activeParams$1 = activeParams.concat(Stdlib_Array.keepSome([
    Stdlib_Option.map(params.minPrice, minPrice => [
      `From $` + Stdlib_Option.getOr(Stdlib_Array.findMap(priceOptions, v => {
        if (v.value === minPrice) {
          return v.label;
        }
      }), minPrice.toString()),
      p => {
        let newrecord = {...p};
        newrecord.minPrice = undefined;
        return newrecord;
      }
    ]),
    Stdlib_Option.map(params.maxPrice, maxPrice => [
      `Up to $` + Stdlib_Option.getOr(Stdlib_Array.findMap(priceOptions, v => {
        if (v.value === maxPrice) {
          return v.label;
        }
      }), maxPrice.toString()),
      p => {
        let newrecord = {...p};
        newrecord.maxPrice = undefined;
        return newrecord;
      }
    ])
  ]));
  if (rentalMode) {
    Stdlib_Option.getOr(params.rentalNeedPropertyTypes, []).forEach(rentalPropertyType => {
      let tmp;
      tmp = rentalPropertyType === "CONDO" ? "Condo" : "Single-family";
      activeParams$1.push([
        tmp,
        p => {
          let newrecord = {...p};
          newrecord.rentalNeedPropertyTypes = SearchPagesUtils.toggleIncluded(p.rentalNeedPropertyTypes, rentalPropertyType);
          return newrecord;
        }
      ]);
    });
    if (params.purchasedOrRented) {
      activeParams$1.push([
        "Rented",
        p => {
          let newrecord = {...p};
          newrecord.purchasedOrRented = false;
          return newrecord;
        }
      ]);
    }
  } else {
    Stdlib_Option.getOr(params.buyerNeedPropertyTypes, []).forEach(buyingPropertyType => {
      let tmp;
      switch (buyingPropertyType) {
        case "CONDO" :
          tmp = "Condo";
          break;
        case "LOT" :
          tmp = "Lot";
          break;
        case "MULTI_UNIT" :
          tmp = "Multi-unit";
          break;
        case "SINGLE_FAMILY" :
          tmp = "Single-family";
          break;
      }
      activeParams$1.push([
        tmp,
        p => {
          let newrecord = {...p};
          newrecord.buyerNeedPropertyTypes = SearchPagesUtils.toggleIncluded(p.buyerNeedPropertyTypes, buyingPropertyType);
          return newrecord;
        }
      ]);
    });
    if (params.purchasedOrRented) {
      activeParams$1.push([
        "Purchased",
        p => {
          let newrecord = {...p};
          newrecord.purchasedOrRented = false;
          return newrecord;
        }
      ]);
    }
    if (params.inContract) {
      activeParams$1.push([
        "In Contract",
        p => {
          let newrecord = {...p};
          newrecord.inContract = false;
          return newrecord;
        }
      ]);
    }
  }
  if (params.withdrawnOrExpired) {
    activeParams$1.push([
      "Withdrawn / Expired",
      p => {
        let newrecord = {...p};
        newrecord.withdrawnOrExpired = false;
        return newrecord;
      }
    ]);
  }
  if (params.active) {
    activeParams$1.push([
      "Active",
      p => {
        let newrecord = {...p};
        newrecord.active = false;
        return newrecord;
      }
    ]);
  }
  let keywords = params.keywords;
  if (keywords !== undefined && keywords.length !== 0) {
    activeParams$1.push([
      "Keywords: " + Utils.$$Array.joinWith(", ", keywords),
      p => {
        let newrecord = {...p};
        newrecord.keywords = [];
        return newrecord;
      }
    ]);
  }
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        activeParams$1.length !== 0 ? activeParams$1.map(param => {
            let updater = param[1];
            let text = param[0];
            return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(FilterChip.make, {
                children: text,
                closeHandler: () => refetch(undefined, undefined, undefined, updater)
              })
            }, text);
          }) : JsxRuntime.jsx("div", {
            children: "No filters"
          }),
        activeParams$1.length > 1 || !params.active ? JsxRuntime.jsx("button", {
            children: "Reset filters",
            className: "self-center underline pl-2",
            type: "button",
            onClick: param => refetch(undefined, undefined, undefined, param => ClientNeedsPageRelayQueryParams.getDefaultState())
          }) : null
      ],
      className: "flex grow flex-row gap-2 flex-wrap"
    }),
    className: "flex flex-row"
  });
}

let QueryParams;

let make = ClientNeedsPageRelayActiveFiltersList;

exports.QueryParams = QueryParams;
exports.make = make;
/* Utils Not a pure module */
